import React from "react";
import { Box, Tooltip } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import {
  faGithub,
  faLinkedin,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";

import "../styles/index.scss";
import Section from "./Section";
import { en, links } from "../content";

function Footer() {
  const content = en.footer;
  return (
    <Box className="footer">
      <Section>
        <Box>
          <Box display="flex" alignItems="center" justifyContent="center">
            <Box mx={3}>
              <Tooltip placement="top" title="Visit GitHub">
                <Box
                  className="icon"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <a href={links.github} target="_blank" rel="noreferrer">
                    <FontAwesomeIcon className="icon" icon={faGithub} />
                  </a>
                </Box>
              </Tooltip>
            </Box>

            <Box mx={3}>
              <Tooltip placement="top" title="Visit LinkedIn Profile">
                <Box
                  className="icon"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <a href={links.linkedin} target="_blank" rel="noreferrer">
                    <FontAwesomeIcon className="icon" icon={faLinkedin} />
                  </a>
                </Box>
              </Tooltip>
            </Box>

            <Box mx={3}>
              <Tooltip placement="top" title="Follow me on Instagram">
                <Box
                  className="icon"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <a href={links.instagram} target="_blank" rel="noreferrer">
                    <FontAwesomeIcon className="icon" icon={faInstagram} />
                  </a>
                </Box>
              </Tooltip>
            </Box>

            <Box mx={3}>
              <Tooltip placement="top" title="Send me an e-mail">
                <Box
                  className="icon"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <a
                    href={`mailto:${links.email}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon className="icon" icon={faEnvelope} />
                  </a>
                </Box>
              </Tooltip>
            </Box>
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            mt={4}
          >
            <Box textAlign="center">{content.message}</Box>
            <Box mt={1}>{content.copyright}</Box>
          </Box>
        </Box>
      </Section>
    </Box>
  );
}

export default Footer;
